<template>
  <router-view />
</template>

<script>
export default {
  name: 'StorageItemsIndex'
}
</script>

